import React from 'react';

// Import images
import b2bEcommerce from "../../assets/img/features/b2b-Ecommerce.png";
import announceGif from "../../assets/img/announce.gif";
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

const AIB2C = () => {
  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">AI B2C E-Commerce Solutions</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <a href="#">Home</a>
            </li>
            <li className="breadcrumb-item active text-primary">AI B2C E-Commerce Solutions</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5 col-lg-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bEcommerce}
                    className="img-fluid rounded w-45"
                    alt="B2b E-Commerce"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7">
              <h1 className="text-left mb-4">Transform Your Business with a Scalable B2C Ecosystem</h1>
              <p className="text-left font-size-p">
                At Epic-X, we offer next-generation B2C eCommerce solutions designed to streamline customer ordering, product management, and last-mile delivery. With AI-driven insights, real-time analytics, and seamless third-party integrations, businesses can enhance efficiency, improve decision-making, and provide a superior customer experience.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Key Features & Benefits Section */}
      <header className="sub-heading-section">
        <h1>Key Features & Benefits</h1>
      </header>
      <div className="container mt-5">
        <div className="row g-4">
          <div className="col-md-6">
            <h3>Customer Ordering Mobile App</h3>
            <ul className="list-unstyled">
              <li><span className="icon-box"></span> User-Friendly & Intuitive Interface</li>
              <li><span className="icon-box"></span> Smart Search & Voice Ordering</li>
              <li><span className="icon-box"></span> Secure Multi-Payment Gateway Integration</li>
              <li><span className="icon-box"></span> Real-Time Order Tracking & Notifications</li>
              <li><span className="icon-box"></span> Loyalty & Rewards Program</li>
            </ul>
          </div>
          <div className="col-md-6">
            <h3>Delivery Partner App</h3>
            <ul className="list-unstyled">
              <li><span className="icon-box"></span> Optimized Route Planning with GPS & AI</li>
              <li><span className="icon-box"></span> Automated Task Assignment</li>
              <li><span className="icon-box"></span> Live Order Tracking & Status Updates</li>
              <li><span className="icon-box"></span> Delivery Agent Performance Analytics</li>
              <li><span className="icon-box"></span> Seamless Payment & Earnings Tracking</li>
            </ul>
          </div>
        </div>

        <div className="row g-4 mt-4">
          <div className="col-md-6">
            <h3>Vendor & Product Management System</h3>
            <ul className="list-unstyled">
              <li><span className="icon-box"></span> Centralized Vendor Dashboard</li>
              <li><span className="icon-box"></span> AI-Powered Stock Replenishment</li>
              <li><span className="icon-box"></span> Multi-Vendor Marketplace Support</li>
              <li><span className="icon-box"></span> Dynamic Pricing & Demand Forecasting</li>
              <li><span className="icon-box"></span> Product Performance Insights</li>
            </ul>
          </div>
          <div className="col-md-6">
            <h3>Analytical Dashboard for Business Intelligence</h3>
            <ul className="list-unstyled">
              <li><span className="icon-box"></span> Real-Time Sales & Revenue Reports</li>
              <li><span className="icon-box"></span> Customer Behavior Analysis</li>
              <li><span className="icon-box"></span> Inventory & Supply Chain Optimization</li>
              <li><span className="icon-box"></span> Fraud Detection & Security Monitoring</li>
              <li><span className="icon-box"></span> Marketing & ROI Insights</li>
            </ul>
          </div>
        </div>

        <div className="row g-4 mt-4">
          <div className="col-md-6">
            <h3>Seamless Third-Party Integrations</h3>
            <ul className="list-unstyled">
              <li><span className="icon-box"></span> AI-Enhanced SMS & Notification Services</li>
              <li><span className="icon-box"></span> Mapping & Location Intelligence</li>
              <li><span className="icon-box"></span> Secure Payment Gateway Integration</li>
              <li><span className="icon-box"></span> CRM & Marketing Automation</li>
              <li><span className="icon-box"></span> AI Chatbots & Customer Support</li>
            </ul>
          </div>
          <div className="col-md-6">
            <h3>Future-Proof Your B2C Business with AI & Automation</h3>
            <ul className="list-unstyled">
              <li><span className="icon-box"></span> Seamless Mobile & Web Integration</li>
              <li><span className="icon-box"></span> AI-Optimized Customer & Vendor Experiences</li>
              <li><span className="icon-box"></span> Scalable Cloud Infrastructure</li>
              <li><span className="icon-box"></span> Secure & Compliant Payment Processing</li>
            </ul>
          </div>
        </div>

        {/* Call to Action Section */}
        <h4 className="mt-4">
          <img src={announceGif} className="w-50px" alt="announcement" /> Ready to Scale Your Business?
        </h4>
        <p className="font-size-p">
          Let’s build the future of eCommerce with intelligent automation, seamless integrations, and AI-driven insights.
        </p>
        <div className="row g-4 mb-5">
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-map-marker-alt fa-2x"></i>
              </div>
              <div>
                <h4>Website</h4>
                <p className="mb-0">
                  <a href="https://epic-x.io/">epic-x.io</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-envelope fa-2x"></i>
              </div>
              <div>
                <h4>Mail Us</h4>
                <p className="mb-0">techsupport@epic-x.io</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fa fa-phone-alt fa-2x"></i>
              </div>
              <div>
                <h4>Call Us</h4>
                <p className="mb-0">+91-8925696660</p>
              </div>
            </div>
          </div>
        <h4>Empower your business with scalable, intelligent, and future-ready B2C solutions today! 🚀</h4>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default AIB2C